module.exports = __webpack_public_path__ + "static/media/TUNE_6510.e8f80a43.jpg";